import PropTypes from 'prop-types';
import React from 'react';
import BannerWithBottomImage from './Banners/BannerWithBottomImage';
// import BannerWithSideImage from './Banners/BannerWithSideImage';

export default function ClassBannerPreview({
  imageDetails,
  selectedImage = 0,
  isDiscoverable,
  ...props
}) {
  return (
    <>
      {selectedImage === 0 && (
        <BannerWithBottomImage
          className={imageDetails.className}
          teacherName={imageDetails.teacherName}
          image={imageDetails.assetUrl}
          isDiscoverable={isDiscoverable}
          {...props}
        />
      )}
      {/* {selectedImage === 1 && (
        <BannerWithSideImage
          className={imageDetails.className}
          teacherName={imageDetails.teacherName}
          image={imageDetails.assetUrl}
        />
      )} */}
    </>
  );
}

ClassBannerPreview.propTypes = {
  imageDetails: PropTypes.object,
  selectedImage: PropTypes.number,
  isDiscoverable: PropTypes.bool
};
